import React from 'react';
import { useBlogPosts } from '../hooks/useBlogPosts';
import BlogCard from '../components/blog/BlogCard';

function BlogPage({ onViewPost }) {
  const { posts, loading, error } = useBlogPosts();

  if (loading) {
    return (
      <div className="py-16 md:py-24 text-center">
        <div className="section-title">Our Blog</div>
        <p className="text-xl text-gray-600">Loading latest articles...</p>
        <div className="mt-8 inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-indigo-600 motion-reduce:animate-[spin_1.5s_linear_infinite]" role="status">
          <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="section-title">Our Blog</h1>
        {error && <p className="text-center text-red-500 mb-8 bg-red-100 p-4 rounded-md">{error}</p>}
        {posts.length === 0 && !loading && !error && (
          <p className="text-center text-xl text-gray-600">No blog posts found. Check your Contentful setup or add some posts!</p>
        )}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {posts.map(post => (
            <BlogCard key={post.sys.id} post={post} onViewPost={onViewPost} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogPage; 